import { useMutation } from '@tanstack/react-query';
import { organizationsRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';

export const useEnableOrganization = () =>
  useMutation<ApiResponse<unknown>, unknown, number>((id) =>
    organizationsRepo.enableOrganization(id),
  );
